import type { InputProps } from 'antd/es/input';

import { Component } from './styles';

const Input: React.FC<InputProps> = (props) => {
  return (
    <Component {...props} />
  )
}

export default Input;
